import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { ClockCounterClockwise, User } from "@phosphor-icons/react";

export default function AuditLog() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/audit-logs?limit=300")
      .then((r) => setItems(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Failed to load"))
      .finally(() => setLoading(false));
  }, []);

  if (user?.role !== "organization_owner") {
    return <div className="p-8 text-muted-foreground">Only the organization owner can view audit logs.</div>;
  }

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="overline text-muted-foreground mb-2">Security</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight leading-none">Audit Log</h1>
        <p className="text-sm text-muted-foreground mt-2">Every important action in your workspace, most recent first.</p>
      </div>
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/40 text-xs uppercase text-muted-foreground tracking-wider">
              <tr><th className="text-left p-4">When</th><th className="text-left p-4">Who</th><th className="text-left p-4">Action</th><th className="text-left p-4">Target</th><th className="text-left p-4">IP</th></tr>
            </thead>
            <tbody>
              {items.map((e) => (
                <tr key={e.id} className="border-t border-border/40" data-testid={`log-${e.id}`}>
                  <td className="p-4 text-xs text-muted-foreground whitespace-nowrap">{new Date(e.created_at).toLocaleString("en-IN")}</td>
                  <td className="p-4"><div className="text-xs font-medium">{e.user_name || "—"}</div><div className="text-[10px] text-muted-foreground">{e.user_email}</div></td>
                  <td className="p-4"><span className="text-xs px-2 py-0.5 rounded bg-secondary font-mono">{e.action}</span></td>
                  <td className="p-4 text-xs text-muted-foreground">{e.entity_type ? `${e.entity_type}${e.entity_id ? " · "+e.entity_id.slice(0,8) : ""}` : "—"}</td>
                  <td className="p-4 text-xs text-muted-foreground font-mono">{e.ip || "—"}</td>
                </tr>
              ))}
              {!loading && !items.length && !error && <tr><td colSpan={5} className="p-10 text-center text-muted-foreground"><ClockCounterClockwise size={22} className="mx-auto mb-2 opacity-40" />No activity yet.</td></tr>}
              {error && <tr><td colSpan={5} className="p-6 text-destructive">{error}</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
